import {
	RECEIVE_IMPORT_CONTEXT,
	RECEIVE_CATALOG_IMPORT_RESULT,
} from '../constants/catalogImport';

const initialState = {
	isEmpty: false,
	// Par défaut « pas un fils » : tant que le serveur n'a pas répondu, on
	// n'affiche pas de refus d'accès à quelqu'un qui y a droit. La porte
	// serveur (403) reste le vrai garde-fou.
	isChild: false,
	// Travail en zone : l'import y est fermé pour la même raison qu'un fils —
	// une zone est un périmètre de déploiement, pas une carte. Comme isChild,
	// à false tant que le serveur n'a pas répondu.
	isZone: false,
	// Master dont la carte n'est plus vierge : l'import y reste un outil
	// d'amorçage, le réimport est fermé. Le serveur combine les deux faits
	// (mode master + carte remplie) en un seul drapeau — le sessionStorage du
	// navigateur ne sait pas distinguer un fils connecté en direct d'un master
	// descendu dans une maison. Comme les deux précédents, à false tant qu'il
	// n'a pas répondu.
	isMasterReimport: false,
	importResult: null,
	// Nombre de réponses reçues du serveur pour une tentative d'import, échec
	// compris. `importResult` seul ne suffit pas à détecter « une réponse est
	// arrivée » : deux échecs consécutifs le laissent à `false` avant comme
	// après, sans aucun changement de valeur à observer.
	importAttemptsCompleted: 0,
};

export default function catalogImportReducer(state = initialState, action) {
	switch (action.type) {
		case RECEIVE_IMPORT_CONTEXT:
			return {
				...state,
				isEmpty: action.isEmpty,
				isChild: action.isChild,
				isZone: action.isZone,
				isMasterReimport: action.isMasterReimport,
			};
		case RECEIVE_CATALOG_IMPORT_RESULT:
			return {
				...state,
				importResult: action.result,
				importAttemptsCompleted: state.importAttemptsCompleted + 1,
			};
		default:
			return state;
	}
}
